import { render, staticRenderFns } from "./beyondPayReportList.vue?vue&type=template&id=31cac0f5"
import script from "./beyondPayReportList.vue?vue&type=script&lang=js"
export * from "./beyondPayReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports